export const CATEGORYVIEW_TOP_REQUEST = "CATEGORYVIEW_TOP_REQUEST";
export const CATEGORYVIEW_TOP_ERROR = "CATEGORYVIEW_TOP_ERROR";
